import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { EGDSButtonSize } from '../../button/button/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSFloatingFullWidthButton } from '../../button/floating-full-width-button/index.esm.js';
import { EGDSTertiaryButton } from '../../button/tertiary-button/index.esm.js';
import '../../button/paging-button/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import { EGDSScrim } from '../../scrim/scrim/index.esm.js';
import { EGDSScrimType } from '../../scrim/types/index.esm.js';
import '../../toolbar/toolbar/index.esm.js';
import { EGDSToolbar } from '../../toolbar/egds-toolbar/index.esm.js';
import '../../toolbar/toolbar-container/index.esm.js';
import '../../toolbar/transparent-toolbar/index.esm.js';
import { EGDSToolbarButton } from '../../toolbar/toolbar-button/index.esm.js';
import { EGDSCalendar } from '../calendar/index.esm.js';
import '../date-field/index.esm.js';
import '../date-picker/index.esm.js';
import '../day/index.esm.js';
import '../month/index.esm.js';
import { EGDSDatePickerInput } from '../date-picker-input/index.esm.js';
import '../date-picker-menu-view/index.esm.js';
import styles from '../../styles/uitk-egds-date-picker.css';
import { useIdCompatibility } from '../../utils/use-id-compatibility/index.esm.js';
import { liveAnnounce, Level } from '../../utils/live-announce/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class DatePickerDialogView extends React.Component {
  static displayName = 'EGDSDatePickerDialogView';
  doneButtonRef;
  buttonText;
  constructor(props) {
    super(props);
    this.doneButtonRef = React.createRef();
    this.state = {
      localizedText: {
        cancelButton: () => props.l10n.formatText('datePicker.cancelButton.a11yLabel'),
        datePickerOpened: () => props.l10n.formatText('datePicker.datePickerOpened.liveAnnounce'),
        doneButtonFare: (nights, lowestFareMessage, startDate, endDate) => {
          if (nights <= 1) {
            return props.l10n.formatText('datePicker.doneButtonFareWithSummary.single.a11yLabel', startDate, lowestFareMessage);
          }
          return props.l10n.formatText('datePicker.doneButtonFareWithSummary.multiple.a11yLabel', startDate, endDate, lowestFareMessage);
        },
        clearInstructions: () => props.l10n.formatText('datePicker.clearInstructions.a11yLabel'),
        doneInstructions: () => props.l10n.formatText('datePicker.doneInstructions.a11yLabel'),
        hiddenDoneButton: (nights, startDate, endDate) => {
          if (nights <= 1) {
            return props.l10n.formatText('datePicker.doneButtonWithSummary.single.a11yLabel', startDate);
          }
          return props.l10n.formatText('datePicker.doneButtonWithSummary.multiple.a11yLabel', startDate, endDate);
        },
        // The "nightSummary" function is written like this to support older versions of uitk-react-localization (pre HoB)
        // if you are graduating this component please change this function to
        // nightSummary: (nights: number) => props.l10n.formatText('datePicker.nightSummary', nights),
        // and ensure teams are on the latest version of uitk-react-localization
        nightSummary: nights => props.l10n.formatText('datePicker.nightSummary', nights) || (nights <= 1 ? props.l10n.formatText('datePicker.nightSummary.single', nights) : props.l10n.formatText('datePicker.nightSummary.multiple', nights)),
        skipToButton: buttonName => props.l10n.formatText('datePicker.skipToButton', buttonName)
      },
      selection: props.selection
    };
    this.onClickTopStart = this.onClickTopStart.bind(this);
    this.onClickTopEnd = this.onClickTopEnd.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onDismissClick = this.onDismissClick.bind(this);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.internallyUpdateDatePicker = this.internallyUpdateDatePicker.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.hiddenDoneButton = this.hiddenDoneButton.bind(this);
    this.skipToDoneButton = this.skipToDoneButton.bind(this);
  }
  componentDidMount() {
    const {
      localizedText
    } = this.state;
    liveAnnounce(localizedText.datePickerOpened(), Level.ASSERTIVE);
  }
  shouldComponentUpdate(nextProps) {
    if (nextProps && nextProps.holidays && nextProps.holidays.length > 0) {
      const {
        selection
      } = this.props;
      selection.configureHolidays(nextProps.holidays);
    }
    return true;
  }
  onClickTopStart() {
    const {
      onSelectStartMode
    } = this.props;
    onSelectStartMode();
    this.internallyUpdateDatePicker();
  }
  onClickTopEnd() {
    const {
      onSelectEndMode
    } = this.props;
    onSelectEndMode();
    this.internallyUpdateDatePicker();
  }
  onSubmitClick() {
    const {
      onSubmit,
      onDoneButtonClickCB
    } = this.props;
    if (onDoneButtonClickCB) {
      const {
        selection
      } = this.props;
      const {
        start,
        end
      } = selection;
      onDoneButtonClickCB(start, end);
    } else {
      onSubmit();
    }
  }
  onDismissClick() {
    const {
      onDismiss
    } = this.props;
    onDismiss();
  }
  onChangeStartDate(date) {
    const {
      onChangeStartDate
    } = this.props;
    if (onChangeStartDate) {
      onChangeStartDate(date, true);
    }
  }
  onChangeEndDate(date) {
    const {
      onChangeEndDate
    } = this.props;
    if (onChangeEndDate) {
      onChangeEndDate(date, false);
    }
  }
  /* Creating another state */
  onSelectDate() {
    this.internallyUpdateDatePicker();
  }
  // Workaround to having FullscreenDialog in the middle of the tree
  internallyUpdateDatePicker() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState(this.state);
  }
  /* ********************** */
  skipToDoneButton() {
    const {
      localizedText
    } = this.state;
    const onClick = () => {
      if (this.doneButtonRef && this.doneButtonRef.current) {
        this.doneButtonRef.current.focus();
      }
    };
    return jsx("button", {
      type: "button",
      className: [getClassNameList('uitk-date-picker-skip-to-done'), 'is-visually-hidden'].join(' '),
      onClick: onClick,
      children: localizedText.skipToButton(this.buttonText)
    });
  }
  hiddenDoneButton() {
    const {
      formattedStartSelection,
      formattedEndSelection,
      selection
    } = this.props;
    const {
      localizedText
    } = this.state;
    const nights = selection.numberOfNights;
    const startDate = formattedStartSelection;
    const endDate = formattedEndSelection;
    const visuallyHiddenText = localizedText.hiddenDoneButton(nights, startDate, endDate);
    return jsx(EGDSTertiaryButton, {
      className: "hidden-done-button",
      onClick: this.onSubmitClick,
      children: visuallyHiddenText
    });
  }
  renderApplyButton(doneAnalytics, buttonText) {
    const {
      localizedText
    } = this.state;
    const {
      submitDisabled
    } = this.props;
    return jsx(EGDSFloatingFullWidthButton, {
      analytics: doneAnalytics,
      "data-stid": "apply-date-picker",
      disabled: submitDisabled,
      domRef: this.doneButtonRef,
      isFullWidth: true,
      onClick: this.onSubmitClick,
      size: EGDSButtonSize.LARGE,
      "aria-label": localizedText.doneInstructions(),
      children: buttonText
    });
  }
  render() {
    const {
      buttonText,
      clearButtonText,
      footerText,
      closeAnalytics,
      datePickerContent,
      doneAnalytics,
      endSelectedMsg,
      firstDayOfWeek,
      formattedStartSelection,
      lastValidDate,
      onScrollHandler,
      selectionClassNames,
      startSelectedMsg,
      singleMode,
      updateDatePicker,
      labels,
      l10n,
      uId,
      holidays,
      firstValidDate,
      useClearDates,
      onClearDates
    } = this.props;
    this.buttonText = buttonText;
    const {
      selection
    } = this.state;
    const startSelection = selection.start;
    const endSelection = selection.end;
    const isDateSelected = singleMode ? startSelection : startSelection && endSelection;
    const startSelectionFormatted = startSelection ? l10n.formatDate(startSelection, {
      dateFormat: 'full',
      skeleton: 'MMMEd'
    }) : formattedStartSelection;
    const formattedEndSelection = endSelection ? l10n.formatDate(endSelection, {
      dateFormat: 'full',
      skeleton: 'MMMEd'
    }) : l10n.formatText('datePicker.dateInput.endDate.placeholder');
    const {
      localizedText
    } = this.state;
    const showHolidaysInfo = !!(selection.holidaysConfigured && selection.holidaysName !== '');
    const isScrim = !!(!footerText && !selection.holidaysConfigured);
    const scrimPaddingClassname = getClassNameList({
      'uitk-calendar-scrim': isScrim
    });
    const clearDatesButtonId = `clear-date-picker-${uId}`;
    if (!selection.holidaysName) {
      selection.holidaysName = [];
    }
    return jsxs(EGDSLayoutFlex, {
      direction: "column",
      className: getClassNameList('uitk-date-picker', 'date-picker-dialog'),
      children: [jsx(EGDSLayoutFlexItem, {
        children: jsxs(EGDSToolbar, {
          className: getClassNameList('uitk-date-picker-toolbar'),
          navigationContent: {
            navIconLabel: localizedText.cancelButton(),
            onClick: this.onDismissClick,
            onClickAnalytics: closeAnalytics
          },
          ...(useClearDates && {
            toolbarActionContent: jsx(EGDSToolbarButton, {
              "aria-label": localizedText.clearInstructions(),
              buttonId: clearDatesButtonId,
              disabled: !isDateSelected,
              onClick: onClearDates,
              children: clearButtonText
            })
          }),
          children: [jsxs(EGDSLayoutFlex, {
            alignItems: "center",
            className: getClassNameList('uitk-date-picker-selection-bar', 'uitk-date-picker-selection-bar-top'),
            tag: "section",
            children: [jsx(EGDSLayoutFlexItem, {
              children: jsx(EGDSDatePickerInput, {
                cssClassNames: selectionClassNames(true),
                isDialog: true,
                onClick: this.onClickTopStart,
                selectionDate: startSelectionFormatted,
                selectionDateMsg: `${labels.start} ${startSelectedMsg}`,
                selection: selection.start,
                singleMode: singleMode
              })
            }), !singleMode && jsxs(Fragment, {
              children: [jsx(EGDSLayoutFlexItem, {
                className: getClassNameList('uitk-date-picker-selection-icon'),
                children: jsx(EGDSIcon, {
                  name: "arrow_forward",
                  size: EGDSIconSize.SMALL
                })
              }), jsx(EGDSLayoutFlexItem, {
                children: jsx(EGDSDatePickerInput, {
                  cssClassNames: selectionClassNames(false),
                  isDialog: true,
                  onClick: this.onClickTopEnd,
                  selectionDate: formattedEndSelection,
                  selectionDateMsg: `${labels.end} ${endSelectedMsg}`,
                  selection: selection.end
                })
              })]
            })]
          }), jsx(EGDSLayoutFlex, {
            children: jsx(EGDSLayoutFlexItem, {
              children: this.hiddenDoneButton()
            })
          })]
        })
      }), jsx(EGDSLayoutFlexItem, {
        children: jsx(EGDSCalendar, {
          buttonText: buttonText,
          className: scrimPaddingClassname,
          firstMonth: firstValidDate,
          skipToDoneButton: this.skipToDoneButton,
          datePickerContent: datePickerContent,
          isDialog: true,
          selection: selection,
          selectionStart: selection.start,
          selectionEnd: selection.end,
          startDate: firstValidDate,
          endDate: lastValidDate,
          updateDatePicker: updateDatePicker,
          firstDayOfWeek: firstDayOfWeek,
          onSelectDate: this.onSelectDate,
          singleMode: singleMode,
          holidays: holidays,
          onChangeStartDate: this.onChangeStartDate,
          onChangeEndDate: this.onChangeEndDate,
          onScrollHandler: onScrollHandler
        })
      }), jsxs(EGDSLayoutFlexItem, {
        children: [isScrim && jsx(EGDSScrim, {
          type: EGDSScrimType.BUTTON,
          className: getClassNameList('uitk-date-picker-footer'),
          children: this.renderApplyButton(doneAnalytics, buttonText)
        }), !isScrim && jsxs("div", {
          className: getClassNameList('uitk-date-picker-footer-opaque'),
          children: [showHolidaysInfo && jsx("div", {
            className: getClassNameList('uitk-date-picker-footer-text'),
            children: jsx("p", {
              children: selection.holidaysName
            })
          }), footerText && jsx("p", {
            className: getClassNameList('uitk-date-picker-footer-text', {
              'uitk-date-picker-footer-text-center': !showHolidaysInfo
            }),
            children: footerText
          }), this.renderApplyButton(doneAnalytics, buttonText)]
        })]
      })]
    });
  }
}
const EGDSDatePickerDialogView = props => {
  const l10n = useLocalization();
  const uId = useIdCompatibility();
  return jsx(DatePickerDialogView, {
    l10n: l10n,
    uId: uId,
    ...props
  });
};
EGDSDatePickerDialogView.displayName = 'EGDSDatePickerDialogView';
const EGDSNewDatePickerDialogView = EGDSDatePickerDialogView;
export { EGDSDatePickerDialogView, EGDSNewDatePickerDialogView };